module.exports = "<link href=\"https://fonts.googleapis.com/icon?family=Material+Icons\" rel=\"stylesheet\">\n<link rel=\"stylesheet\" href=\"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic\">\n\n<mat-toolbar id=\"toolbar\" color=\"primary\">  \n  <div id=\"toolbar_title\">\n    <a routerLink=\"/dashboard\">\n      <button mat-mini-fab color=\"accent\">\n        <mat-icon>account_balance</mat-icon>\n      </button>\n    </a>\n  </div>\n</mat-toolbar>\n\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main